import React, { useState } from 'react';
import { ArrowRight, Search } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import LatestNewItems from '../components/LatestNewItems';
import { useLanguage } from '../hooks/useLanguage';

export default function HomePage() {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const { t } = useLanguage();

  const submitSearch = (event) => {
    event.preventDefault();
    const params = new URLSearchParams({
      q: query.trim(),
      searchType: 'all',
      page: '0',
    });
    navigate('/search?' + params.toString());
  };

  const directions = [
    { to: '/year', title: t('home.serialTitle') },
    { to: '/gallery', title: t('home.galleryTitle') },
    { to: '/manufacturers', title: t('home.manufacturersTitle') },
    { to: '/modifications', title: t('home.modificationsTitle') },
    { to: '/articles', title: t('home.articlesTitle') },
    { to: '/tools/sokolov-identifier', title: t('home.identifierTitle') },
  ];

  return (
    <main className="archive-home">
      <section className="archive-intro page-width">
        <div className="archive-intro__copy">
          <h1>{t('home.title')}</h1>
          <p className="archive-intro__lead">{t('home.intro')}</p>

          <form className="archive-search" onSubmit={submitSearch} role="search">
            <Search size={20} aria-hidden="true" />
            <label className="sr-only" htmlFor="archive-search-input">{t('home.searchAction')}</label>
            <input
              id="archive-search-input"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder={t('home.searchPlaceholder')}
            />
            <button type="submit">{t('home.searchAction')}<ArrowRight size={17} /></button>
          </form>
        </div>
      </section>

      <nav className="archive-directions page-width" aria-labelledby="useful-links-title">
        <header className="useful-links__header">
          <h2 id="useful-links-title">{t('home.usefulLinks')}</h2>
        </header>
        <div className="direction-list">
          {directions.map(({ to, title }) => (
            <Link to={to} className="direction-row" key={to}>
              <span className="direction-row__copy"><strong>{title}</strong></span>
              <ArrowRight className="direction-row__arrow" size={19} />
            </Link>
          ))}
        </div>
      </nav>

      <LatestNewItems />
    </main>
  );
}
